<template>
	<div v-if="value">
		<egranty-section-divider
			text="Grupy docelowe"
			icon="people"
		></egranty-section-divider>

		<div class="ma-3 module-dates">
			<v-flex xs12 md12>
				<display-text-component
					class="modular"
					:label="'Grupy docelowe'"
					:value="beneficiariesList"/>
			</v-flex>
			<v-flex xs12 md12 v-if="value.otherBeneficiaryEnabled">
				<display-text-component
					class="modular"
					:label="''"
					:show-colon="false"
					:value="value.otherBeneficiary"/>
			</v-flex>
		</div>
	</div>
</template>

<script>
	import {AgencyBeneficiary} from "../../../../api/generated/AgencyBeneficiary";
	import DisplayTextComponent from "../../offer/components/DisplayTextComponent";
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";

	export default {
		name: "AgencyChooseBeneficiariesReadOnlyView",
		components: {EgrantySectionDivider, DisplayTextComponent},

		computed: {
			beneficiariesList() {
				if (!this.value || !this.options) return "";
				let beneficiaries = [];
				for (let itemId of this.value.selected) {
					let found = this.options.find(item => item.id === itemId);
					if (found) beneficiaries.push(found.name);
				}
				return beneficiaries.join(', ');
			}
		},

		methods: {
			getContestId () {
				return this.$route.params.id;
			},

			validate () {
				return true;
			},
		},

		mounted () {
			AgencyBeneficiary.getAllBeneficiaries(
				this,
				this.getContestId(),
				response => {
					this.options = response;
				},
			);

		},

		data () {
			return {
				options: [],

			};
		},

		props: {
			value: {}
		},
	};
</script>

<style scoped>

</style>
